module.exports = "/_next/static/images/lab-bg-top-6ec0971f2758d50cb97ac86aa1208970.svg";